export const updateAlert = (id: string, title: string, message: string, type: string) => {
    const itaration = document.querySelector(`.custom-alerts[data-id="${id}"]`) as HTMLElement;

    if (!itaration) return;

    const heading = itaration.querySelector('h3');
    const content = itaration.querySelector('div');

    if (heading) {
        heading.innerHTML = title;
    }

    if (message) {
        content.innerHTML = message;
    }

    if (type) {
        itaration.dataset.style = type;
    }

    itaration.classList.remove('d-none');
}

export const clearAlert = (id) => {
    const itaration = document.querySelector(`.custom-alerts[data-id="${id}"]`) as HTMLElement;
    if (!itaration) return;

    itaration.classList.add('d-none');
}